import type { FaireProductEntity } from "../../entity_types/product";

export const p_njh9mgcnwr: FaireProductEntity = {
  token: "p_njh9mgcnwr",
  type: "product",
  name: "Goldies- Marigold ceramic sgraffito Trinket Dish",
  brandToken: "b_gwc29r2uee",
  brandName: "Tough Kitty Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/d30d4c848e0c057f7dd536f862bb7595fdc1a6fd2ef8eeee1ec2e79b70ef2517.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3a340f0f011c600e9a93260a44e264f3333375088e36d42286f1225cbbec9d3c.jpeg",
  ],
  priceDollars: 15,
  description:
    'These handmade, sgraffito trinket dishes are great for holding your special items. Each one is hand cut and glazed, making each slightly unique. Featuring a sweet marigold design in yellow, orange and red.\n\nMeasures approximately 4"x8", 1/4" thick. Clear glazed. Not intended for food, but is food safe. Hand wash only.',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:58.483Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
